import {
    AfterViewInit,
    ChangeDetectionStrategy,
    Component,
    computed,
    ElementRef,
    HostListener,
    inject,
    input,
    signal,
    viewChild,
    ViewEncapsulation,
} from '@angular/core';
import { TariffSize, TariffStore, TariffType } from '../../../../../tariff';
import { TariffTableAppearance } from '../tariff.table';
import { IndexToTariffSizePipe } from '../pipes';
import { NgClass, NgStyle, NgTemplateOutlet } from '@angular/common';
import { ISbAsset } from '@seven1/model';
import { ITariffSectionBlok } from './tariff.section.model';
import { TailwindService } from '@seven1/angular-storyblok/tailwind';
import { TariffEntry } from '../entry';

@Component({
    selector: 'app-tariff-section',
    imports: [IndexToTariffSizePipe, NgTemplateOutlet, NgClass, NgStyle, TariffEntry],
    templateUrl: './tariff.section.html',
    styleUrl: './tariff.section.scss',
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: {
        '[class]': 'getDisplayClasses()',
    },
})
export class TariffSection implements AfterViewInit {
    private _tailwind = inject(TailwindService);
    tariffStore = inject(TariffStore);
    readonly baseClass = 'app-tariff-section';
    entriesElem = viewChild<ElementRef<HTMLDivElement>>('entriesElem');
    scrollHeight = signal(0);
    block = input.required<ITariffSectionBlok>();

    appearance = input<TariffTableAppearance>('3-columns');
    tariff = input.required<TariffType>();
    size = input<TariffSize>();
    selectedIcon = input.required<ISbAsset>();
    selectedIconActive = input.required<ISbAsset>();
    unselectedIcon = input.required<ISbAsset>();
    topsellerTariff = input<TariffSize>();
    topsellerText = input<string>();

    collapsed = signal<boolean>(false);

    getDisplayClasses = computed(() => {
        return this._tailwind.getDisplayClasses(this.block());
    });

    @HostListener('window:resize')
    onResize() {
        this.resize()
    }

    ngAfterViewInit() {
        this.resize()
    }

    toggle() {
        this.collapsed.set(!this.collapsed());
    }

    resize(){
        const entriesElem = this.entriesElem();
        if (entriesElem) {
            this.scrollHeight.set(entriesElem.nativeElement.scrollHeight);
        }
    }
}
